<template>
  <v-layout class="text-xs-center fill-height" column justify-center pb-5>
    <div class="display-2 font-weight-medium px-5">
      К сожалению, этот раздел недоступен для смартфонов
    </div>
    <div><img src="/images/devices.png" class="my-5" /></div>
    <div class="headline font-weight-medium px-5">
      Не расстраивайтесь, вы можете посмотреть его на планшете или с компьютера
    </div>
  </v-layout>
</template>

<script>
export default {
  name: "SectionNotForPhone",

  components: {},

  data: () => ({})
};
</script>
